import { combineReducers } from "redux";
// slices
import authSlice from "./slices/authSlice";
import badgeSlice from "./slices/badgeSlice";
import cancelReasonSlice from "./slices/cancelReasonSlice";
import categorySlice from "./slices/categorySlice";
import commissionSlice from "./slices/commissionSlice";
import customerSlice from "./slices/customerSlice";
import dashboardSlice from "./slices/dashboardSlice";
import deletedUserSlice from "./slices/deletedUserSlice";
import documentTypeSlice from "./slices/documentTypeSlice";
import emergencyContactSlice from "./slices/emergencyContactSlice";
import faqSlice from "./slices/faqSlice";
import fareSlice from "./slices/fareSlice";
import notificationSlice from "./slices/notificationSlice";
import placeSlice from "./slices/placeSlice";
import promoCodeSlice from "./slices/promoCodeSlice";
import ratingSlice from "./slices/ratingSlice";
import reportSlice from "./slices/reportSlice";
import reportTypeSlice from "./slices/reportTypeSlice";
import rewardSlice from "./slices/rewardSlice";
import riderSlice from "./slices/riderSlice";
import rideSlice from "./slices/rideSlice";
import roleSlice from "./slices/roleSlice";
import serviceAreaSlice from "./slices/serviceAreaSlice";
import settingSlice from "./slices/settingSlice";
import socketSlice from "./slices/socketSlice";
import suspendPolicySlice from "./slices/suspendPolicySlice";
import teamSlice from "./slices/teamSlice";
import transactionSlice from "./slices/transactionSlice";
import userOTPSlice from "./slices/userOTPSlice";
import userSlice from "./slices/userSlice";
import userTypeSlice from "./slices/userTypeSlice";
import vehicleSlice from "./slices/vehicleSlice";
import walletSlice from "./slices/walletSlice";

// ----------------------------------------------------------------------

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  team: teamSlice,
  role: roleSlice,
  userType: userTypeSlice,
  userOTP: userOTPSlice,
  deletedUser: deletedUserSlice,
  vehicle: vehicleSlice,
  faq: faqSlice,
  promoCode: promoCodeSlice,
  badge: badgeSlice,
  commission: commissionSlice,
  reward: rewardSlice,
  dashboard: dashboardSlice,
  category: categorySlice,
  wallet: walletSlice,
  documentType: documentTypeSlice,
  reportType: reportTypeSlice,
  report: reportSlice,
  customer: customerSlice,
  rider: riderSlice,
  place: placeSlice,
  emergencyContact: emergencyContactSlice,
  cancelReason: cancelReasonSlice,
  suspendPolicy: suspendPolicySlice,
  serviceArea: serviceAreaSlice,
  fare: fareSlice,
  socket: socketSlice,
  ride: rideSlice,
  setting: settingSlice,
  transaction: transactionSlice,
  rating: ratingSlice,
  notification: notificationSlice,
});

export default rootReducer;
